import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sideString',
  standalone: true,
})
export class SideStringPipe implements PipeTransform {
  transform(value?: string): string {
    if (value === 'r') {
      return 'rechts';
    } else if (value === 'l') {
      return 'links';
    } else {
      return 'beide';
    }
  }
}
